import styled from 'styled-components';

export const Label = styled.div`
  font-size: 1.4rem;
  color: #fff;
  display: flex;
  align-items: center;
  margin-left: 20px;
  padding: 12px 26px;
  color: ${(props) => (props.dark ? 'inherited' : '#ffffff')};
`;
